var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_315245)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.9672 50.0139C39.7743 50.0139 50.9672 38.9752 50.9672 25.3583C50.9672 11.7413 39.7743 0.702637 25.9672 0.702637C12.1601 0.702637 0.967224 11.7413 0.967224 25.3583C0.967224 38.9752 12.1601 50.0139 25.9672 50.0139Z",
    fill: "url(#paint0_radial_4655_315245)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0807 8.20605C15.2091 8.20605 6.39896 16.8948 6.39896 27.61C6.39896 38.3253 15.2091 47.0206 26.0807 47.0206C36.9523 47.0206 45.7557 38.3319 45.7557 27.61C45.7557 16.8882 36.9456 8.20605 26.0807 8.20605ZM26.0807 42.4974C17.7406 42.4974 10.9853 35.8352 10.9853 27.61C10.9853 19.3849 17.7406 12.7292 26.0807 12.7292C34.4207 12.7292 41.1693 19.3915 41.1693 27.61C41.1693 35.8286 34.414 42.4974 26.0807 42.4974Z",
    fill: "url(#paint1_linear_4655_315245)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0798 11.375C16.9876 11.375 9.61456 18.6465 9.61456 27.6068C9.61456 36.5671 16.9876 43.8452 26.0798 43.8452C35.1719 43.8452 42.5383 36.5737 42.5383 27.6068C42.5383 18.6399 35.1652 11.375 26.0798 11.375ZM26.0798 42.4942C17.7397 42.4942 10.9844 35.832 10.9844 27.6068C10.9844 19.3816 17.7397 12.726 26.0798 12.726C34.4198 12.726 41.1684 19.3882 41.1684 27.6068C41.1684 35.8253 34.4131 42.4942 26.0798 42.4942Z",
    fill: "url(#paint2_linear_4655_315245)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2004 15.54C9.99225 16.4473 11.906 17.9638 12.2418 18.1426C12.5775 18.3281 17.0162 11.0499 26.0814 11.381C35.1467 11.7056 39.9748 18.1559 40.3307 18.4208C40.6866 18.6857 42.9697 18.1493 42.9697 18.1493C42.9697 18.1493 38.1282 7.77178 26.3769 8.08304C14.6256 8.40092 10.2004 15.54 10.2004 15.54Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7758 12.0463C30.3662 11.9404 33.4618 9.31122 33.6968 9.41718C33.9318 9.52314 37.8534 11.4967 38.6122 12.3841C39.371 13.2715 38.2764 16.351 38.2697 16.3443C38.263 16.3377 35.9262 13.3576 30.7691 12.0463H30.7758Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7866 19.5494C11.7866 19.5494 17.4675 12.7216 26.0828 12.7216C34.6982 12.7216 40.5805 19.9137 40.5805 19.9137C40.5805 19.9137 35.4436 11.3706 26.3179 11.3706C17.1921 11.3706 11.7866 19.5494 11.7866 19.5494Z",
    fill: "#5C7459"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73866 29.5689C9.73866 29.5689 8.35536 23.6218 11.9613 19.251C11.9613 19.251 9.58421 22.7742 9.73866 29.5689Z",
    fill: "#61573B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1122 15.2157C36.9979 15.1229 38.0732 14.8578 38.3286 15.0831C38.584 15.3085 38.3286 16.4087 38.3286 16.4087C38.3286 16.4087 37.2668 15.3482 37.1122 15.2157Z",
    fill: "#5C5644"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 17.353C11.1674 17.2669 10.3885 15.6709 11.436 14.1742C12.4835 12.6775 15.0621 11.4524 16.1768 11.161C17.2982 10.8696 16.1902 14.1146 15.2031 15.4259C14.216 16.7371 11.7919 17.353 11.7919 17.353H11.7852Z",
    fill: "#A49C84"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19 23.5572L7.87601 24.0075V26.034L8.91684 26.3122C8.91684 26.3122 8.3192 12.0075 26.0737 10.0671V0.0141602C26.0737 0.0141602 21.7627 0.325418 18.2507 2.04727L18.9491 6.06052L17.9082 6.37178L17.2166 4.00092C17.2166 4.00092 11.7506 5.68303 8.03717 11.7625L8.95713 13.1267C8.95713 13.1267 5.53918 17.9413 5.19 23.5572Z",
    fill: "url(#paint3_linear_4655_315245)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2469 2.04492L17.6359 3.80651L18.2469 6.27009L18.7103 6.13101L19.9995 9.52174L18.2469 2.04492Z",
    fill: "#1F200B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03149 11.7607L8.63585 13.721L8.85073 13.3237L12.0068 15.9992L8.03149 11.7607Z",
    fill: "#1F200B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19046 23.5586L6.52782 25.0764L6.56814 24.7516L7.87189 25.0764V24.0159L5.19046 23.5586Z",
    fill: "#1F200B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2442 12.1289L16.5185 7.85742C16.5185 7.85742 13.866 9.01636 12.0127 11.3806L14.5711 14.4137L18.2509 12.1289H18.2442Z",
    fill: "url(#paint4_linear_4655_315245)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0658 1.59863C26.0658 1.59863 22.7486 2.04896 20.4722 3.00923L21.5936 8.51916L26.0658 8.06883V1.59863Z",
    fill: "url(#paint5_linear_4655_315245)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5687 11.2568C12.5687 11.2568 14.2676 9.52169 16.2754 8.74023C16.2754 8.74023 17.7929 11.5879 17.8064 11.9853C17.8064 11.9853 16.1545 13.2435 14.7376 13.8793L12.5687 11.2568Z",
    fill: "url(#paint6_linear_4655_315245)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95799 15.3154L10.7442 16.6201C10.7442 16.6201 9.01843 19.4214 8.03804 22.9048L6.366 22.6399C6.366 22.6399 6.64803 17.9379 8.95799 15.3154Z",
    fill: "url(#paint7_linear_4655_315245)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4292 16.7294L9.04594 15.7427C9.04594 15.7427 7.22617 17.9612 6.64868 22.2129L8.03198 22.4182C8.03198 22.4182 9.00565 19.5241 10.4292 16.7294Z",
    fill: "#1F200B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0683 2.04492C26.0683 2.04492 22.8115 2.4489 21.1059 3.3032C21.1059 3.3032 21.8244 8.19062 21.9452 8.20386C22.0594 8.21711 26.0683 7.85287 26.0683 7.85287V2.04492Z",
    fill: "#1F200B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9442 23.5572L44.2582 24.0075V26.034L43.2174 26.3122C43.2174 26.3122 43.815 12.0075 26.0605 10.0671V0.0141602C26.0605 0.0141602 30.3716 0.325418 33.8835 2.04727L33.1852 6.06052L34.226 6.37178L34.9177 4.00092C34.9177 4.00092 40.3837 5.68303 44.0971 11.7625L43.1771 13.1267C43.1771 13.1267 46.5951 17.9413 46.9442 23.5572Z",
    fill: "url(#paint8_linear_4655_315245)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8928 2.04492L34.5039 3.80651L33.8928 6.27009L33.4295 6.13101L32.1402 9.52174L33.8928 2.04492Z",
    fill: "#1F200B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1038 11.7607L43.4994 13.721L43.2912 13.3237L40.1285 15.9992L44.1038 11.7607Z",
    fill: "#1F200B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9466 23.5586L45.616 25.0764L45.5689 24.7516L44.2652 25.0764V24.0159L46.9466 23.5586Z",
    fill: "#1F200B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8901 12.1289L35.6159 7.85742C35.6159 7.85742 38.2683 9.01636 40.1217 11.3806L37.5633 14.4137L33.8834 12.1289H33.8901Z",
    fill: "url(#paint9_linear_4655_315245)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0671 1.59863C26.0671 1.59863 29.3843 2.04896 31.6607 3.00923L30.5393 8.51916L26.0671 8.06883V1.59863Z",
    fill: "url(#paint10_linear_4655_315245)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5664 11.2568C39.5664 11.2568 37.8675 9.52169 35.8597 8.74023C35.8597 8.74023 34.3421 11.5879 34.3286 11.9853C34.3286 11.9853 35.9805 13.2435 37.3974 13.8793L39.5664 11.2568Z",
    fill: "url(#paint11_linear_4655_315245)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1774 15.3154L41.3912 16.6201C41.3912 16.6201 43.1169 19.4214 44.0973 22.9048L45.7694 22.6399C45.7694 22.6399 45.4873 17.9379 43.1774 15.3154Z",
    fill: "url(#paint12_linear_4655_315245)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7068 16.7294L43.0901 15.7427C43.0901 15.7427 44.9099 17.9612 45.4874 22.2129L44.1041 22.4182C44.1041 22.4182 43.1304 19.5241 41.7068 16.7294Z",
    fill: "#1F200B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0671 2.04492C26.0671 2.04492 29.3239 2.4489 31.0295 3.3032C31.0295 3.3032 30.311 8.19062 30.1901 8.20386C30.0759 8.21711 26.0671 7.85287 26.0671 7.85287V2.04492Z",
    fill: "#1F200B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2118 4.00537L18.7105 6.1329L17.904 6.37813L17.2118 4.00537Z",
    fill: "#61573B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9005 4.11719L33.4288 6.13867L34.2352 6.3839L34.9005 4.11719Z",
    fill: "#61573B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1188 25.0705L41.7092 30.3884L44.5698 36.0903L46.9469 31.5274L44.5967 28.1764L48.6257 26.3155L47.9676 21.5605L42.1188 25.0705Z",
    fill: "url(#paint13_linear_4655_315245)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.624 26.314L45.7164 28.8239V28.3603L44.595 28.1749L48.624 26.314Z",
    fill: "#BDA700"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5693 36.0926L42.9778 37.5694L43.5889 36.2714L42.1183 31.5694H40.6343L40.1306 30.8012L40.2179 25.2449L42.1183 25.0728L41.7087 30.3906L44.5693 36.0926Z",
    fill: "#1F200B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9671 21.5622L46.6778 21.4629L46.7584 21.9L43.0651 24.1914L40.829 24.4298L40.218 25.2443L42.1183 25.0722L47.9671 21.5622Z",
    fill: "#61573B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7345 26.9229L46.6668 31.1215L44.847 28.5321C44.847 28.5321 46.4116 27.4527 47.7345 26.9229Z",
    fill: "url(#paint14_linear_4655_315245)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1193 25.0749L41.1792 25.161C41.1792 25.161 41.9917 24.4457 42.8176 24.2206C43.6436 23.9954 45.2552 23.2007 45.2552 23.2007L42.126 25.0749H42.1193Z",
    fill: "#746B50"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0459 25.0705L10.4556 30.3884L7.59496 36.0903L5.21785 31.5274L7.5681 28.1764L3.53909 26.3155L4.19716 21.5605L10.0459 25.0705Z",
    fill: "url(#paint15_linear_4655_315245)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53909 26.314L6.44669 28.8239V28.3603L7.5681 28.1749L3.53909 26.314Z",
    fill: "#BDA700"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59555 36.0926L9.19372 37.5694L8.57594 36.2714L10.0465 31.5694H11.5305L12.0342 30.8012L11.9469 25.2449L10.0465 25.0728L10.4561 30.3906L7.59555 36.0926Z",
    fill: "#1F200B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19894 21.5622L5.48823 21.4629L5.40765 21.9L9.1009 24.1914L11.337 24.4298L11.9481 25.2443L10.0477 25.0722L4.19894 21.5622Z",
    fill: "#61573B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43192 26.9229L5.4996 31.1215L7.31937 28.5321C7.31937 28.5321 5.75477 27.4527 4.43192 26.9229Z",
    fill: "url(#paint16_linear_4655_315245)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0461 25.0749L10.9862 25.161C10.9862 25.161 10.1737 24.4457 9.34771 24.2206C8.52176 23.9954 6.91016 23.2007 6.91016 23.2007L10.0394 25.0749H10.0461Z",
    fill: "#746B50"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6107 12.1929C34.4024 11.7223 34.6242 11.1987 36.2841 10.9535C37.9373 10.7083 37.5542 12.8026 37.3392 13.2798C37.1174 13.7504 34.6174 12.1995 34.6174 12.1995L34.6107 12.1929Z",
    fill: "#FF7C00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.74 13.7273C14.3371 13.5816 13.914 12.1114 15.2302 10.9525C16.553 9.79357 17.4797 11.3565 17.5133 11.8664C17.5468 12.3763 14.74 13.7273 14.74 13.7273Z",
    fill: "#FF7C00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53543 11.5514C8.53543 11.5514 10.8588 11.0746 13.0614 9.80308C15.2639 8.53156 17.2112 4.46533 17.2112 4.46533C17.2112 4.46533 11.7989 5.97527 8.53543 11.5514Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3143 2.3343C18.3143 2.3343 23.0484 1.5396 26.0769 1.5992C29.0986 1.65881 32.7382 2.7449 32.8859 2.7449C33.0336 2.7449 33.8461 2.28132 33.8461 2.28132C33.8461 2.28132 29.8843 0.155495 26.0769 0.215097C22.2694 0.2747 18.3143 2.32768 18.3143 2.32768V2.3343Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2191 4.11719C35.2191 4.11719 35.9376 6.36884 37.106 7.69335C38.2744 9.01785 43.2234 11.3821 43.2234 11.3821C43.2234 11.3821 42.5721 7.74633 35.2191 4.11719Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2109 4.47021C17.2109 4.47021 15.3038 5.21856 14.3368 6.16558C13.3699 7.1126 13.1953 9.72187 13.1953 9.72187C13.1953 9.72187 16.7945 5.84108 17.2109 4.47021Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6064 2.28937C18.6064 2.28937 20.1106 1.43507 22.2325 0.832416C24.3545 0.229767 26.5771 0.223145 26.5771 0.223145C26.5771 0.223145 26.0467 1.03109 24.0523 1.48142C22.0512 1.93175 18.6064 2.28275 18.6064 2.28275V2.28937Z",
    fill: "#A49C84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2191 4.11719C35.2191 4.11719 37.7171 5.11719 38.4289 5.95825C39.1407 6.79931 39.5167 9.42182 39.5167 9.42182C39.5167 9.42182 36.2868 7.5609 35.2191 4.12381V4.11719Z",
    fill: "#A49C84"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2156 6.37911C36.2156 6.37911 36.4979 6.19353 36.9481 6.89608C37.4051 7.59863 37.1094 7.53898 37.1094 7.53898C37.1094 7.53898 36.5113 7.67153 36.2156 6.37911Z",
    fill: "#70664C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1448 2.10765C20.1448 2.10765 19.8962 1.57743 20.8706 1.47801C21.8451 1.37859 22.2349 1.83591 22.2349 1.83591C22.2349 1.83591 22.3021 2.27997 20.1516 2.10765H20.1448Z",
    fill: "#70664C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7788 35.8811C39.2344 35.7618 38.5826 36.8488 39.0328 37.664C39.4764 38.4726 41.0153 36.1462 39.7788 35.8811Z",
    fill: "#1F200B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0049 36.6734C39.0049 37.2964 39.8046 37.2699 40.0801 36.9252C40.3624 36.574 40.2885 35.8449 39.7038 35.878C39.1124 35.9112 39.0049 36.6734 39.0049 36.6734Z",
    fill: "#78BE99"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8918 37.2105C39.033 36.8261 39.537 37.2437 39.826 37.2437C40.115 37.2437 39.6714 37.8865 39.3354 37.8269C38.9994 37.7606 38.8918 37.2105 38.8918 37.2105Z",
    fill: "#61573B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81152 27.4238C9.30749 27.6491 9.43517 28.9018 10.2887 29.2928C11.1287 29.6839 10.9674 26.9068 9.81152 27.4238Z",
    fill: "#1F200B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67088 28.5029C10.0472 29 10.6722 28.5161 10.6857 28.0721C10.6991 27.628 10.2018 27.0779 9.75153 27.4491C9.29454 27.8202 9.67088 28.5029 9.67088 28.5029Z",
    fill: "#78BE99"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9049 29.0131C9.78393 28.6221 10.4425 28.6618 10.671 28.4895C10.8995 28.3172 10.9331 29.0993 10.6307 29.2451C10.3216 29.3909 9.9049 29.0131 9.9049 29.0131Z",
    fill: "#61573B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7862 38.4072C13.7862 38.4072 19.8432 42.6257 26.3903 42.4999C32.9442 42.3741 38.6049 38.1489 38.6049 38.1489C38.6049 38.1489 34.5289 43.0893 26.8805 43.831C19.2321 44.5728 13.7795 38.4072 13.7795 38.4072H13.7862Z",
    fill: "#61573B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3932 13.6735C17.3932 13.6735 19.7569 11.4284 23.7859 10.7794C27.8149 10.1304 30.7762 12.051 30.7762 12.051C30.7762 12.051 28.661 10.8854 24.0881 11.5543C19.5152 12.2232 17.3999 13.6735 17.3999 13.6735H17.3932Z",
    fill: "#70664C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2096 43.5546C29.2096 43.5546 29.4715 42.7334 31.533 41.8063C33.5945 40.8791 36.1194 40.356 36.1194 40.356C36.1194 40.356 32.3388 43.2632 29.2096 43.5613V43.5546Z",
    fill: "#70664C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7658 40.3512L33.5761 39.9473C29.2114 41.9539 26.1963 41.8082 26.1963 41.8082C26.1963 41.8082 22.6172 42.2188 18.8165 39.9473L15.6269 40.3512C15.6269 40.3512 17.0841 47.8943 17.8093 48.636C17.8093 48.636 22.2815 49.5698 26.3978 49.5698C30.5141 49.5698 35.2213 48.5168 35.2213 48.5168C35.5839 47.4108 36.7658 40.3579 36.7658 40.3579V40.3512Z",
    fill: "url(#paint17_linear_4655_315245)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8165 39.9473C18.8165 39.9473 23.3962 41.8082 26.1963 41.8082C28.9965 41.8082 33.5761 39.9473 33.5761 39.9473L36.7658 40.3512C36.7658 40.3512 31.8504 42.1989 26.3911 42.1989C20.9318 42.1989 15.6269 40.3512 15.6269 40.3512L18.8165 39.9473Z",
    fill: "#61573B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.398 42.4243C17.398 42.4243 28.8471 43.7024 35.5151 41.9541C35.5151 41.9541 35.3002 45.8283 34.8033 47.7289C34.8033 47.7289 28.0412 50.0137 18.4253 47.9011C18.4253 47.9011 17.3912 45.0534 17.398 42.4243Z",
    fill: "url(#paint18_linear_4655_315245)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9845 42.7217C17.9845 42.7217 28.7017 43.874 34.9399 42.2979C34.9399 42.2979 34.7385 45.7813 34.2751 47.4833C34.2751 47.4833 27.9496 49.5363 18.9515 47.6422C18.9515 47.6422 17.9845 45.0859 17.9912 42.7217H17.9845Z",
    fill: "#1F200B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3898 42.2003C26.3898 42.2003 29.1698 41.4387 30.6203 41.0745C32.0707 40.7103 35.8983 40.644 35.8983 40.644C35.8983 40.644 30.9963 42.1871 26.3898 42.2003Z",
    fill: "#70664C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4522 48.7828C27.4522 48.7828 28.2849 48.5907 30.1181 48.2596C31.9513 47.9351 34.0128 47.9483 34.0128 47.9483C34.0128 47.9483 30.9575 48.69 27.4522 48.7828Z",
    fill: "#70664C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6369 33.2417C10.6369 33.2417 11.1003 34.798 12.1277 36.2351C12.1277 36.2351 11.5435 34.6457 10.6369 33.2417Z",
    fill: "#70664C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19254 37.5719C9.19254 37.5719 11.6032 37.2143 12.9597 37.9825C14.3161 38.7507 15.8807 41.6116 15.8807 41.6116L16.532 44.5918C16.532 44.5918 12.1001 42.1878 9.18582 37.5719H9.19254Z",
    fill: "#5C7459"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1257 44.3016C36.1257 44.3016 36.7234 40.8976 36.992 40.3545C37.2606 39.8049 42.3438 37.4473 42.3438 37.4473C42.3438 37.4473 39.96 41.1824 39.0535 42.2022C38.147 43.2221 36.119 44.3082 36.119 44.3082L36.1257 44.3016Z",
    fill: "#5C7459"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55372 30.9123C5.55372 30.9123 5.38571 30.0573 5.71501 29.5006C6.04431 28.9438 7.11957 28.6323 7.11957 28.6323L5.56044 30.9123H5.55372Z",
    fill: "#FF7C00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1655 28.6241C45.1655 28.6241 46.0055 28.591 46.4356 29.0284C46.8657 29.4658 46.6641 31.1294 46.6641 31.1294L45.1655 28.6241Z",
    fill: "#FF7C00"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.4177 10.0651C16.3919 8.68096 18.6683 8.4889 19.501 9.64784C20.3336 10.8002 19.407 12.8664 17.4327 14.2505C15.4585 15.6346 13.1821 15.8267 12.3495 14.6677C11.5168 13.5154 12.4435 11.4492 14.4177 10.0651Z",
    fill: "url(#paint19_radial_4655_315245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M34.2938 8.41927C36.1673 7.10139 38.766 7.53848 40.1023 9.38616C41.4386 11.2338 40.9954 13.7968 39.1219 15.1146C37.2484 16.4325 34.6497 15.9954 33.3134 14.1477C31.9771 12.3001 32.4203 9.73715 34.2938 8.41927Z",
    fill: "url(#paint20_radial_4655_315245)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21.244 32.4406H18.9532V19.8965H21.244V32.4406Z",
    fill: "#FAFF66"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1161 32.4406H24.8254V19.8965H27.1161V32.4406Z",
    fill: "#FAFF66"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9883 32.4406H30.6976V19.8965H32.9883V32.4406Z",
    fill: "#FAFF66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315245",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9672 25.3583) scale(25 24.6556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F9D300",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B89C00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#806C00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#524500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315245",
    x1: 26.0807,
    y1: 47.0206,
    x2: 26.0807,
    y2: 8.20605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25271C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38341F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315245",
    x1: 26.0798,
    y1: 43.8452,
    x2: 26.0798,
    y2: 11.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315245",
    x1: 15.6251,
    y1: 26.3188,
    x2: 15.6251,
    y2: 0.0141602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23250F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38341F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315245",
    x1: 15.1217,
    y1: 14.4137,
    x2: 15.1217,
    y2: 7.85742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A79D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E3C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315245",
    x1: 23.2656,
    y1: 8.51916,
    x2: 23.2656,
    y2: 1.59863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315245",
    x1: 15.7516,
    y1: 13.6078,
    x2: 14.5475,
    y2: 9.22167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315245",
    x1: 8.54838,
    y1: 22.9048,
    x2: 8.54838,
    y2: 15.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315245",
    x1: 36.5024,
    y1: 26.3188,
    x2: 36.5024,
    y2: 0.0141602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23250F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38341F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315245",
    x1: 37.0059,
    y1: 14.4137,
    x2: 37.0059,
    y2: 7.85742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A79D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E3C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315245",
    x1: 28.8605,
    y1: 8.51916,
    x2: 28.8605,
    y2: 1.59863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315245",
    x1: 36.3834,
    y1: 13.6078,
    x2: 37.5876,
    y2: 9.22167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315245",
    x1: 43.5803,
    y1: 22.9048,
    x2: 43.5803,
    y2: 15.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315245",
    x1: 45.1674,
    y1: 36.0903,
    x2: 45.1674,
    y2: 21.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38341F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315245",
    x1: 47.2107,
    y1: 30.9758,
    x2: 46.2095,
    y2: 27.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315245",
    x1: 6.99733,
    y1: 36.0903,
    x2: 6.99733,
    y2: 21.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32321D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38341F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315245",
    x1: 4.95569,
    y1: 30.9758,
    x2: 5.95696,
    y2: 27.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315245",
    x1: 26.1963,
    y1: 49.5698,
    x2: 26.1963,
    y2: 39.9473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23250F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38341F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315245",
    x1: 26.4565,
    y1: 48.7952,
    x2: 26.4565,
    y2: 41.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181905"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4655_315245",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3053 11.8875) rotate(-125.806) scale(2.58591 4.36005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F9C229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B8901E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#806415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#52400D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2E2407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#141003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4655_315245",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1497 10.3035) rotate(-125.806) scale(4.11547 4.13388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F9C229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B8901E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#806415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#52400D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2E2407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#141003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_315245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.971863)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldLeague);
export default __webpack_public_path__ + "static/media/gold-league.18a1ee409d8929879a0bd50368628980.svg";
export { ForwardRef as ReactComponent };